<div class="xlsx-viewer">
  <div class="status" *ngIf="loading">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span>Procesando hoja de cálculo...</span>
  </div>
  <div class="status error" *ngIf="error">
    <i class="fa-solid fa-circle-exclamation"></i>
    <span>{{ error }}</span>
  </div>
  <div class="truncated-warning" *ngIf="truncatedWarning">
    <i class="fa-solid fa-triangle-exclamation"></i>
    Solo se muestran las primeras 5,000 filas por hoja. Descarga el archivo para verlo completo.
  </div>
  <p-tabView *ngIf="!loading && !error && sheets.length > 0" [(activeIndex)]="activeSheetIndex">
    <p-tabPanel *ngFor="let sheet of sheets; let i = index; trackBy: trackByIdx" [header]="sheet.name">
      <div class="table-wrapper">
        <table class="xlsx-table">
          <tbody>
            <tr *ngFor="let row of sheet.rows; trackBy: trackByIdx">
              <td *ngFor="let cell of row; trackBy: trackByIdx">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
